import React from 'react';

import { ComparisonTable } from '@/app/_components/ComparisonTable';
import { ComparisonTableProps } from './types';

import classes from './index.module.scss';

export const ComparisonTableGraphQL: React.FC<ComparisonTableProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <ComparisonTable comparisonTable={props} />
    </div>
  );
};

export default ComparisonTableGraphQL;
